<template lang="pug">
  .layout
    y-dialog(v-model="showModal" fill-height fluid scrollable persistent :fullscreen="$vuetify.breakpoint.xsOnly" transition="fade-transition" max-width="600px")
      v-card
        v-card-title.pa-0
          v-row.px-5.pt-3.pb-2(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('product_notes') }}

        v-card-text.pa-0
          v-text-field.mx-4.mt-2.mb-4(v-model="searchText" placeholder='Search product note' hide-details dense outlined height="40" background-color="basic200")
            template(v-slot:append)
              eva-icon(v-if="!searchText" name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600" )
          div.mb-2.mx-4(v-if="notes.length > 0")
            div.d-flex.align-center
              v-btn.s1.text-capitalize.px-0(color="textColorAccent" text @click="clickAddProduct")
                eva-icon.mr-3(name="plus-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="20" height="20" style="margin-top: 3px")
                | {{ $t('create_new_note') }}
          
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

          .contain-layout(v-else)
            v-layout.my-6(v-if="notes.length == 0")
              v-row.fill-height.ma-0(align='center' justify='center')
                div.mx-auto.text-center
                  v-img.mx-auto.my-4(:src="require('@/assets/images/icon_empty_notes.png')" style="width:80px; height:80px" contain)
                  div.mt-2
                    .caption {{ $t('use_feature_to_collect') }}
                    .caption  {{ $t('from_customers_about') }}
                  v-btn.button-AA-tiny.my-6(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="clickAddProduct")
                    template
                      v-icon.mr-1(small) mdi-plus
                      | {{ $t('create_product_notes') }}
                  div.p2.info500--text.text-decoration-underline(@click="openProductNotesImage") {{ $t('what_look_like') }}

            .items-layout(v-else)
              .list-item(three-line)
                template(v-for='note in notes')
                  product-notes-item(:parentNote.sync="note" :key="note.id" @deleted="handleDeleteItem" @edited="handleEditItem")
              
            div.mt-4.px-4
              y-pagination.mt-4.mb-6(v-model="page" :pageSize="fetchCount" :count="totalCount")

    .modals
      add-product-notes(v-if="showAddProductDialog" :open.sync="showAddProductDialog" :company="company" @added="handleAddItem")

</template>

<script>
import { mapState } from 'vuex'
import queryString from 'query-string'
import AddProductNotes from '@/components/productnotes/dialogs/AddProductNotes.vue'
import ProductNotesItem from '@/components/productnotes/ProductNotesItem.vue'

export default {
  name: 'SetProductNotes',
  components: { AddProductNotes, ProductNotesItem },
  props: ['open', 'company'],
  data: () => ({
    showHeader: true,
    lastScrollPosition: 0,
    isFetching: false,
    showAddProductDialog: false,
    isTyping: false,
    fetchCount: 10,
    totalCount: 0,
    page: 1,
    totalPage: 1,
    notes: [],
    searchText: '',
    searchCountDown: null
  }),
  computed: {
    ...mapState('user', ['member']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (!this.$route.query.page) {
      this.fetchNotes(1)
    } else {
      this.fetchNotes(this.$route.query.page)
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchNotes(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  methods: {
    fetchNotes(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/product_notes/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id`
      if (this.searchText) {
        url += `&search=${this.searchText}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.notes = response.data.results
        this.totalCount = response.data.count
        if (this.totalCount % this.fetchCount == 0) {
          this.totalPage = this.totalCount/this.fetchCount
        } else {
          this.totalPage = this.totalCount/this.fetchCount + 1
        }
        this.totalPage = parseInt(this.totalPage)
      })
      .catch(() => {})
    },
    clickAddProduct () {
      this.showAddProductDialog = true
    },
    searchItem () {
      let searchUrl = `/product_notes/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.notes = response.data.results
          this.totalCount = response.data.count
          if (this.totalCount % this.fetchCount == 0) {
            this.totalPage = this.totalCount/this.fetchCount
          } else {
            this.totalPage = this.totalCount/this.fetchCount + 1
          }
          this.totalPage = parseInt(this.totalPage)
        })
        .catch(() => {})
    },
    handleDeleteItem (item) {
      this.notes = this.notes.filter((x) => x !== item)
    },
    handleAddItem (item) {
      this.notes.splice(0, 0, item)
    },
    handleEditItem (item) {
      let editIndex = 0
      this.notes.forEach((note, index) => {
        if (note.id === item.id) {
          editIndex = index
        }
      })
      this.notes = this.notes.filter((x) => x.id !== item.id)
      this.notes.splice(editIndex, 0, item)
    },
    openProductNotesImage () {
      window.open(`../preview_product_notes.jpg`, '_blank')
    }
  }
}
</script>
<style scoped>
.sticky-header-container {
  position: relative;
  background-color: var(--v-basic100);
  height: 80px;
}
.sticky-header{
  position: fixed;
  transition: 0.3s all ease-out;
  transform: translate3d(0, 0, 0) !important;
  z-index: 3;
  width: 100%;
  max-width: 600px;
  background-color: var(--v-basic100);
}
.sticky-header.hidden-header{
  transform: translate3d(0, -100%, 0) !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "create_new_note": "Create new note",
    "use_feature_to_collect": "Use this feature to collect more information",
    "from_customers_about": "from customers about a product"
  },
  "id": {
    "create_new_note": "Buat nota baharu",
    "use_feature_to_collect": "Gunakan fungsi ini untuk mendapatkan lebih info",
    "from_customers_about": "dari pelanggan tentang produk"
  }
}
</i18n>